import Navbar from './Navbar';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Homepage from './Homepage';
import Teams from './Teams';
import Results from './Results';
import Regulations from './Regulations';
import Tasks from './Tasks';
import Organization from './Organization';

function App() {
  return (
    <Router>
      <Navbar />
      <div class="content">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/teams" element={<Teams />} />
          <Route path="/results" element={<Results />} />
          <Route path="/regulations" element={<Regulations />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/organization" element={<Organization />} />
        </Routes>
      </div>
      <footer>
        NAOI 2025 - Algerian Olympiad in Informatics
      </footer>
    </Router>

  );
}

export default App;
